import React from "react";
import AddNewCreateUserLinkFormPresenter from "../NewCreateUserLinkForm/NewCreateUserLinkFormPresenter";
import useQueryURL from "../../../../../common/hooks/useQueryURL";
import ModalDrawer from "../../../../../common/components/organisme/ModalDrawer/ModalDrawer";
import { CreateUserLink } from "../../../types/createUserLink.type";

/**
 *
 *
 * @param param0
 * @returns
 */
export default function NewCreateUserLinkModal({
  modalId,
  organizationId,
}: {
  modalId?: string;
  organizationId?: string | null;
}) {
  const { removeQueryValue} = useQueryURL();
  const MODAL_ID_PARAMS = modalId || "modal_add_user_link";
  const onSuccessfulSubmit = (result: CreateUserLink ) => {
    removeQueryValue([MODAL_ID_PARAMS]);
  };

  return (
    <ModalDrawer
      isOpen={true}
      title="Nouveau lien de création d'utilisateur"
      urlParamName={MODAL_ID_PARAMS}
    >
        <AddNewCreateUserLinkFormPresenter
          onSuccess={onSuccessfulSubmit}
          organizationId={organizationId || undefined}
        />
    </ModalDrawer>
  );
}
